/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {number}
 */

export const ProgramTypeEnum = {
  ADULT_PROGRAM: 1,
  JUNIOR_PROGRAM: 2,
  UNIVERSAL_ACCESS_PROGRAM: 3,
  HIGH_SCHOOL: 4,
} as const;

export type ProgramTypeEnum =
  (typeof ProgramTypeEnum)[keyof typeof ProgramTypeEnum];

export type ProgramTypeEnumEnumType = typeof ProgramTypeEnum;
export type ProgramTypeEnumOptional = ProgramTypeEnum;
export type ProgramTypeEnumTrackedI = ProgramTypeEnum;
export type ProgramTypeEnumTracked = ProgramTypeEnum;
export type ProgramTypeEnumMetaI = EnumMetaType<
  ProgramTypeEnumEnumType,
  ProgramTypeEnum
>;
export const ProgramTypeEnumMeta = typeMetaEnum<
  ProgramTypeEnumEnumType,
  ProgramTypeEnum
>("ProgramTypeEnum", ProgramTypeEnum);
export function transformDatesProgramTypeEnum(model: ProgramTypeEnum) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
